const GFormStyling = () => {

// placeholder styling change on select
document.addEventListener('change', function (e) {
    if (e.target.classList.contains('gfield_select')) {
        if (e.target.value === '') {
            e.target.classList.add('is-placeholder');
        } else {
            e.target.classList.remove('is-placeholder');
        }
    }
});

// Set initial state
document.querySelectorAll('.gfield_select').forEach(function (select) {
    if (select.value === '') {
        select.classList.add('is-placeholder');
    }
});

}

export default GFormStyling;